import { CjsLogin, LinkOptions } from "@cervval.js/client-auth/src/components/login/login.component";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { CustomElement, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { AuthInfos } from "@cervval.js/common-auth/src/authRoutes";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { capitalizeFirstLetter } from "@cervval.js/common/src/tools/string.tools";
import { LOGIN_CLIENT_MAIN_SERVICE, LoginClientMainService } from "../../services/loginClientMainService.service";

@CustomElement({
    name: "login-page",
    style: require("./login.page.scss"),
    template: require("./login.page.html")
})
export class LoginPage extends WebPageComponent {

    @Injected(LOGIN_CLIENT_MAIN_SERVICE)
    private _mainService!: LoginClientMainService;

    @TypedHtmlElements()
    public components!: {
        loginContainer: HTMLDivElement
    };

    /**
     * init : first time the item is inserted into DOM
     */
    public override init(): Promise<void> {
        // Build login component
        return this._mainService.authInfosRoutes.getAuthInfos().then((authInfos: AuthInfos) => {
            const login: CjsLogin = new CjsLogin({
                appName: authInfos.appDisplayName,
                appLogoUrl: authInfos.appLogoUrl,
                login: authInfos.loginFormEnabled ? (login, password) => this._mainService.loginRoutes.formLogin({ login, password }, {
                    doNotLogErrors: true
                }).then((loginResult) => {
                    if (loginResult.redirectAfterLogin) {
                        window.location.href = loginResult.redirectAfterLogin;
                    } else {
                        window.location.href = "..";
                    }
                }) : undefined,
                ssoOptions: authInfos.singleSignOnOptions?.map((s) => {
                    const linkOptions: LinkOptions = {
                        iconCss: s.iconCss,
                        text: capitalizeFirstLetter(s.text),
                        tooltip: s.text,
                        callback: () => {
                            window.location.href = s.url;
                            return Promise.resolve(undefined);
                        }
                    };
                    return linkOptions;
                })
            });
            this.components.loginContainer.append(login);
        });
    }
}